import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import Switch from "react-switch";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";

// Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
  Fn_DeleteData,
  Fn_GetReport,
} from "../../store/functions";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");
  return d2;
};

class pageAddEdit_Order extends Component {
  constructor(props) {
    super(props);
    var today = new Date().toISOString().split("T")[0];
    this.state = {
      id: 0,
      formData: {
        OrderId: "",
        OrderNo: "",
        OrderDate: today,
        DeliveryDate: today,
        LedgerId: "",
      },
      activeTab: 1,
      passedSteps: [1],
      success_msg: false,
      OrderNo: "",
      OrderDate: today,
      DeliveryDate: today,
      LedgerId: "",
      Ledger: [],
      isFormDirty: false,
      isEditMode: false,
      // New state for grid
      gridData: [
        {
          DOD: today,
          StyleNo: "",
          UnitSize: "3",
          ItemType: "1",
          Ply: "",
          Length: "",
          LengthMar: "",
          Width: "",
          WidthMar: "",
          Height: "",
          HeightMar: "",
          Type: "",
          CalcType: "",
          InOut: "",
          BoxQty: "",
          index: 0,
        },
      ],
      activeMarField: null,
      focusedField: null,
      focusedFormField: null,
      // Dropdowns data
      UnitSize: [],
      ItemType: [],
      Ply: [],
      TypeMaster: [],
      CalculationType: [],
      InOutOptions: [
        { Id: "1", Name: "In" },
        { Id: "2", Name: "Out" },
      ],
    };

    this.obj = this;
    this.formTitle = "Order";
    this.breadCrumbTitle = "Orders";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/OrderDetailH";
    this.API_URL_SAVE = API_WEB_URLS.AddEdit + "/0/token";
    this.pushFormName = "/Order";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
    this.handleLedgerChange = this.handleLedgerChange.bind(this);
    this.handleGridChange = this.handleGridChange.bind(this);
    this.addGridRow = this.addGridRow.bind(this);
    this.deleteGridRow = this.deleteGridRow.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleFormFieldChange = this.handleFormFieldChange.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleOrderChange = this.handleOrderChange.bind(this);
    this.handlePrintClick = this.handlePrintClick.bind(this);

    // Add field order for navigation
    this.fieldOrder = [
      "DOD",
      "StyleNo",
      "UnitSize",
      "ItemType",
      "Ply",
      "Length",
      "LengthMar",
      "Width",
      "WidthMar",
      "Height",
      "HeightMar",
      "Type",
      "CalcType",
      "PrintDesc",
      "InOut",
      "BoxQty",
      "Amount",
    ];
  }

  async componentDidMount() {
    const obj = JSON.parse(sessionStorage.getItem("authUser"));
    const today = new Date().toISOString().split("T")[0];

    const LoginDetails =
      JSON.parse(sessionStorage.getItem("loginDetails")) || [];
    console.log("LoginDetails", LoginDetails);
    const newObj = LoginDetails.find(item => item.SubMenu == "Add Order");
    console.log("newObj", newObj);

    this.setState(
      {
        name: obj.username,
        email: obj.email,
        aid: obj.uid,
        role: obj.role,
        newObj: newObj, // Store newObj in state
        formData: {
          ...this.state.formData,
          OrderDate: today,
          DeliveryDate: today,
        },
        OrderDate: today,
        DeliveryDate: today,
        gridData: this.state.gridData.map(row => ({
          ...row,
          DOD: today,
        })),
      },
      () => {
        // If user is Customer, automatically load dropdowns with customer's ledger ID
        if (newObj && newObj.UserRole === "Customer") {
          const customerLedgerId =
            newObj.LedgerId || newObj.F_LedgerMaster || 0;
          this.setState(prevState => ({
            formData: {
              ...prevState.formData,
              LedgerId: customerLedgerId,
            },
            LedgerId: customerLedgerId,
          }));
          // Call loadDropdownsForLedger after a short delay to ensure YearMaster and MonthMaster are loaded
          setTimeout(() => {
            this.loadDropdownsForLedger(customerLedgerId);
          }, 500);
        }
      }
    );

    Fn_FillListData(
      this.obj,
      "YearMaster",
      API_WEB_URLS.MASTER + "/0/token/YearMaster/Id/0"
    );
    Fn_FillListData(
      this.obj,
      "MonthMaster",
      API_WEB_URLS.MASTER + "/0/token/MonthMaster/Id/0"
    );
    const res = await Fn_FillListData(
      this.obj,
      "test",
      API_WEB_URLS.MASTER + "/0/token/OrderNoNew/Id/0"
    );
    if (res && res.length > 0) {
      console.log(res);
      this.setState(prevState => ({
        ...prevState,
        formData: {
          ...prevState.formData,
          OrderNo: res[0].OrderNoNew,
        },
        OrderNo: res[0].OrderNoNew,
      }));
    }

    //Filling Ledger Dropdown
    Fn_FillListData(
      this.obj,
      "Ledger",
      API_WEB_URLS.MASTER + "/0/token/LedgerForInvoice/Id/0"
    );
    // If user is Customer, call OrderDetailHLedger API, otherwise call OrderDetailH API
    if (this.state.newObj && this.state.newObj.UserRole === "Customer") {
      const ledgerIdForOrderArr = this.state.newObj.F_LedgerMaster || 0;
      Fn_FillListData(
        this.obj,
        "OrderArr",
        API_WEB_URLS.MASTER +
          "/0/token/OrderDetailHLedger/Id/" +
          ledgerIdForOrderArr
      );
    } else {
      Fn_FillListData(
        this.obj,
        "OrderArr",
        API_WEB_URLS.MASTER + "/0/token/OrderDetailH/Id/0"
      );
    }

    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
    } else {
      this.setState({ id: 0 });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if any form field has changed
    if (prevState.formData !== this.state.formData) {
      this.setState({ isFormDirty: true });
    }
  }

  handleLedgerChange(event) {
    this.setState({
      LedgerId: event.target.value,
      isFormDirty: true,
    });

    this.loadDropdownsForLedger(event.target.value);
  }

  // Helper method to load dropdowns for a given ledger ID
  loadDropdownsForLedger = async ledgerId => {
    // Wait for YearMaster and MonthMaster to be loaded
    let attempts = 0;
    const maxAttempts = 10;

    while (
      (!this.state.YearMaster || !this.state.MonthMaster) &&
      attempts < maxAttempts
    ) {
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }

    const { F_YearMaster, F_MonthMaster } = this.getMonthYearMasterFromDate(
      this.state.OrderDate
    );

    console.log("YearMaster:", this.state.YearMaster);
    console.log("MonthMaster:", this.state.MonthMaster);
    console.log("F_YearMaster:", F_YearMaster, "F_MonthMaster:", F_MonthMaster);

    const vformData = new FormData();

    // If UserRole is Customer, use the ledgerId from newObj, otherwise use the passed ledgerId
    const ledgerIdToSend =
      this.state.newObj && this.state.newObj.UserRole === "Customer"
        ? this.state.newObj.F_LedgerMaster
        : ledgerId;

    vformData.append("F_LedgerMaster", ledgerIdToSend);
    vformData.append("F_YearMaster", F_YearMaster);
    vformData.append("F_MonthMaster", F_MonthMaster);

    Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      "GetPlyPartyDescriptionRates/0/token",
      "Ply",
      true
    );
    Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      "GetPrintPartyDescriptionRates/0/token",
      "PrintDescription",
      true
    );
    Fn_FillListData(
      this.obj,
      "ItemType",
      API_WEB_URLS.MASTER + "/0/token/ItemTypeBox/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "UnitSize",
      API_WEB_URLS.MASTER + "/0/token/UnitSize/Id/0"
    );
    Fn_FillListData(
      this.obj,
      "CalculationType",
      API_WEB_URLS.MASTER + "/0/token/CalculationType/Id/0"
    );
    Fn_FillListData(
      this.obj,
      "TypeMaster",
      API_WEB_URLS.MASTER + "/0/token/TypeMaster/Id/0"
    );
  };
  getMonthYearMasterFromDate = inputDate => {
    const date = new Date(inputDate);

    const monthNumber = date.getMonth() + 1; // 1 to 12
    const yearString = date.getFullYear().toString();

    const { YearMaster, MonthMaster } = this.state;

    const F_YearMaster = YearMaster
      ? YearMaster.find(item => item.Name == yearString)?.Id || -1
      : -1;

    const monthName = date
      .toLocaleString("default", { month: "long" })
      .toLowerCase();

    const F_MonthMaster = MonthMaster
      ? MonthMaster.find(item => item.Name.toLowerCase() == monthName)?.Id || -1
      : -1;

    return { F_MonthMaster, F_YearMaster };
  };
  safeEval = expression => {
    try {
      // Only allow numbers, operators, and parentheses
      if (!/^[0-9+\-*/().\s]+$/.test(expression)) {
        throw new Error("Invalid characters in expression");
      }
      return Function('"use strict"; return (' + expression + ")")();
    } catch (err) {
      throw new Error("Invalid mathematical expression");
    }
  };

  calculate = (formula, values) => {
    try {
      console.log("Original formula:", formula);
      console.log("Values:", values);

      // Step 1: Convert square brackets to regular parentheses
      let cleanedFormula = formula.replace(/\[/g, "(").replace(/\]/g, ")");

      // Step 2: Remove extra spaces
      cleanedFormula = cleanedFormula.replace(/\s+/g, "");

      console.log("Cleaned formula:", cleanedFormula);

      // Step 3: Replace variables with values (case-insensitive)
      const compiledFormula = cleanedFormula.replace(/([a-zA-Z]+)/g, match => {
        // Try exact match first
        if (values[match] !== undefined) {
          return values[match];
        }
        // Try uppercase match
        const upperKey = match.toUpperCase();
        if (values[upperKey] !== undefined) {
          return values[upperKey];
        }
        // Try lowercase match
        const lowerKey = match.toLowerCase();
        if (values[lowerKey] !== undefined) {
          return values[lowerKey];
        }
        // If no match found, return 0
        console.warn(`Variable '${match}' not found in values, using 0`);
        return "0";
      });

      console.log("Compiled formula:", compiledFormula);

      const result = this.safeEval(compiledFormula);
      console.log("Result:", result);
      return result;
    } catch (err) {
      console.error("Formula evaluation error:", err);
      return "Error in formula: " + err.message;
    }
  };
  calculation = async (type, l, h, w, lMar, hMar, wMar, UnitSize) => {
    const res = await Fn_FillListData(
      this.obj,
      "Calculation",
      API_WEB_URLS.MASTER + "/0/token/CalculationType/Id/" + type
    );
    const formula = res[0]?.Formula || "";
    if (UnitSize == 1) {
      // mm to inches
      l /= 25.4;
      w /= 25.4;
      h /= 25.4;
    } else if (UnitSize == 2) {
      // cm to inches
      l /= 2.54;
      w /= 2.54;
      h /= 2.54;
    }
    // First convert margins to fraction format using formatMargin, then to decimal
    const lengthMarginFraction = this.formatMargin(lMar);
    const heightMarginFraction = this.formatMargin(hMar);
    const widthMarginFraction = this.formatMargin(wMar);

    const lengthMargin = this.fractionToDecimal(lengthMarginFraction);
    const heightMargin = this.fractionToDecimal(heightMarginFraction);
    const widthMargin = this.fractionToDecimal(widthMarginFraction);

    // Add margins to dimensions
    const finalLength = parseFloat(l || 0) + lengthMargin;
    const finalHeight = parseFloat(h || 0) + heightMargin;
    const finalWidth = parseFloat(w || 0) + widthMargin;

    console.log(`Original dimensions: L=${l}, H=${h}, W=${w}`);
    console.log(`Raw margins: LMar=${lMar}, HMar=${hMar}, WMar=${wMar}`);
    console.log(
      `Formatted margins: LMar=${lengthMarginFraction}, HMar=${heightMarginFraction}, WMar=${widthMarginFraction}`
    );
    console.log(
      `Decimal margins: LMar=${lengthMargin}, HMar=${heightMargin}, WMar=${widthMargin}`
    );
    console.log(
      `Final dimensions: L=${finalLength}, H=${finalHeight}, W=${finalWidth}`
    );

    const values = {
      L: finalLength,
      H: finalHeight,
      W: finalWidth,
      PinningFleb: res[0]?.PinningFleb || 0,
      Safai: res[0]?.Safai || 0,
    };
    const result = this.calculate(formula, values);
    return result / 1550;
  };
  handleOrderChange = async event => {
    const orderId = event.target.value;
    this.setState({
      OrderId: orderId,
      isFormDirty: false,
      isEditMode: false,
    });

    if (!orderId) {
      // Set ledger ID based on user role
      const ledgerId =
        this.state.newObj && this.state.newObj.UserRole === "Customer"
          ? this.state.newObj.LedgerId || this.state.newObj.F_LedgerMaster || ""
          : "";

      this.setState({
        formData: {
          ...this.state.formData,
          OrderNo: "",
          OrderDate: new Date().toISOString().split("T")[0],
          DeliveryDate: new Date().toISOString().split("T")[0],
          LedgerId: ledgerId,
        },
        gridData: [
          {
            DOD: new Date().toISOString().split("T")[0],
            StyleNo: "",
            UnitSize: "3",
            ItemType: "1",
            Ply: "",
            Length: "",
            LengthMar: "",
            Width: "",
            WidthMar: "",
            Height: "",
            HeightMar: "",
            Type: "",
            CalcType: "",
            InOut: "",
            BoxQty: "",
            SqMt: "",
            Rate: "",
            Amount: "",
            index: 0,
          },
        ],
      });
      return;
    }

    const res = await Fn_DisplayData(this.obj, orderId, this.API_URL + "/Id");
    const res1 = await Fn_FillListData(
      this.obj,
      "TestArr",
      API_WEB_URLS.MASTER + "/0/token/OrderDetailL/Id/" + orderId
    );

    if (res) {
      const formattedOrderDate = res.OrderDate2
        ? new Date(res.OrderDate2).toISOString().split("T")[0]
        : this.state.OrderDate;
      const formattedDeliveryDate = res.DOD
        ? new Date(res.DOD).toISOString().split("T")[0]
        : this.state.DeliveryDate;

      this.setState({
        formData: {
          ...this.state.formData,
          OrderNo: res.OrderNo,
          OrderDate: formattedOrderDate,
          DeliveryDate: formattedDeliveryDate,
          LedgerId: res.F_LedgerMaster,
          OrderId: res.Id,
        },
        LedgerId: res.F_LedgerMaster,
        OrderDate: formattedOrderDate,
        DeliveryDate: formattedDeliveryDate,
      });

      const ledgerId = res.F_LedgerMaster;

      // Wait for YearMaster and MonthMaster to be loaded before calling getMonthYearMasterFromDate
      let attempts = 0;
      const maxAttempts = 10;

      while (
        (!this.state.YearMaster || !this.state.MonthMaster) &&
        attempts < maxAttempts
      ) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }

      const { F_YearMaster, F_MonthMaster } = this.getMonthYearMasterFromDate(
        this.state.OrderDate
      );

      console.log("handleOrderChange - YearMaster:", this.state.YearMaster);
      console.log("handleOrderChange - MonthMaster:", this.state.MonthMaster);
      console.log(
        "handleOrderChange - F_YearMaster:",
        F_YearMaster,
        "F_MonthMaster:",
        F_MonthMaster
      );

      const vformData = new FormData();
      vformData.append("F_LedgerMaster", ledgerId);
      vformData.append("F_YearMaster", F_YearMaster);
      vformData.append("F_MonthMaster", F_MonthMaster);

      Fn_GetReport(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        "GetPlyPartyDescriptionRates/0/token",
        "Ply",
        true
      );
      Fn_GetReport(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        "GetPrintPartyDescriptionRates/0/token",
        "PrintDescription",
        true
      );
      Fn_FillListData(
        this.obj,
        "ItemType",
        API_WEB_URLS.MASTER + "/0/token/ItemTypeBox/Id/0"
      );
      Fn_FillListData(
        this.obj,
        "UnitSize",
        API_WEB_URLS.MASTER + "/0/token/UnitSize/Id/0"
      );
      Fn_FillListData(
        this.obj,
        "CalculationType",
        API_WEB_URLS.MASTER + "/0/token/CalculationType/Id/0"
      );
      Fn_FillListData(
        this.obj,
        "TypeMaster",
        API_WEB_URLS.MASTER + "/0/token/TypeMaster/Id/0"
      );
    }

    if (res1 && Array.isArray(res1)) {
      const parseMargin = marginStr => {
        if (typeof marginStr === "string" && marginStr.includes("/")) {
          return marginStr.split("/")[0];
        }
        return marginStr || "";
      };

      const newGridData = res1.map((item, index) => ({
        DOD: item.DOD2
          ? new Date(item.DOD2).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0],
        StyleNo: item.CodeNo || "",
        UnitSize: item.F_UnitSize || "",
        ItemType: item.F_ItemType || "",
        Ply: item.F_PlyMaster || "",
        Length: item.Length || "",
        LengthMar: parseMargin(item.LengthMar),
        Width: item.Width || "",
        WidthMar: parseMargin(item.WidthMar),
        Height: item.Height || "",
        HeightMar: parseMargin(item.HeightMar),
        Type: item.F_TypeMaster || "",
        CalcType: item.F_CalculationTypeMaster || "",
        InOut: item.InOut?.toString() || "1",
        BoxQty: item.NoOfBox || "",
        index: index,
        Rate: item.Rate || "",
        Amount: item.Amount || "",
        SqMt: item.SqMt || "",
        PrintDesc :item.PrintDesc
      }));

      if (newGridData.length > 0) {
        this.setState({ gridData: newGridData });
      }
    }
  };

  // Helper function to convert fraction to decimal
  fractionToDecimal = fractionStr => {
    if (!fractionStr || fractionStr === "0") return 0;
    if (fractionStr.includes("/")) {
      const [numerator, denominator] = fractionStr.split("/");
      return parseFloat(numerator) / parseFloat(denominator);
    }
    return parseFloat(fractionStr) || 0;
  };

  handleGridChange = async (index, fieldName, value) => {
    const gridData = [...this.state.gridData];
    let processedValue = value;

    if (["LengthMar", "WidthMar", "HeightMar"].includes(fieldName)) {
      processedValue = value.replace(/[^0-9]/g, "");
    }

    gridData[index][fieldName] = processedValue;

    // Trigger calculation when CalcType is selected OR when Length/Width/Height/Margins change
    if (
      fieldName === "CalcType" ||
      ([
        "Length",
        "Width",
        "Height",
        "LengthMar",
        "WidthMar",
        "HeightMar",
      ].includes(fieldName) &&
        gridData[index].CalcType)
    ) {
      // Wait for state to update first
      await new Promise(resolve => {
        this.setState(
          {
            gridData,
            isFormDirty: true,
          },
          resolve
        );
      });

      // Use updated values from gridData
      const updatedRow = gridData[index];
      const result = await this.calculation(
        updatedRow.CalcType,
        updatedRow.Length,
        updatedRow.Height,
        updatedRow.Width,
        updatedRow.LengthMar,
        updatedRow.HeightMar,
        updatedRow.WidthMar,
        updatedRow.UnitSize
      );

      console.log("Calculation Result:", result);
      gridData[index].SqMt = parseFloat(result.toFixed(2));

      // Debug Ply selection
      console.log("Selected Ply:", gridData[index]["Ply"]);
      console.log("Ply type:", typeof gridData[index]["Ply"]);
      console.log("Available Ply array:", this.state.Ply);

      if (gridData[index]["Ply"]) {
        // Convert to number for comparison
        const selectedPlyId = parseInt(gridData[index]["Ply"]);
        console.log("Converted Ply ID:", selectedPlyId);

        const ob = this.state.Ply.find(item => {
          console.log("Comparing:", item.Id, "with", selectedPlyId);
          return parseInt(item.Id) === selectedPlyId;
        });

        console.log("Found Ply object:", ob);

        if (ob) {
          // gridData[index].Rate = result * ob.Rate;
          gridData[index].Rate = parseFloat((result * ob.Rate).toFixed(2));
          console.log("Calculated Rate:", gridData[index].Rate);

          // Calculate Amount = Rate * BoxQty
          const boxQty = parseFloat(gridData[index].BoxQty) || 0;
          // gridData[index].Amount = gridData[index].Rate * boxQty;
          gridData[index].Amount = parseFloat(
            (gridData[index].Rate * boxQty).toFixed(2)
          );
          console.log("Calculated Amount:", gridData[index].Amount);
        } else {
          console.log("Ply object not found!");
        }
      } else {
        console.log("No Ply selected");
      }

      // Update state with calculated SqMt, Rate and Amount
      this.setState({
        gridData,
        isFormDirty: true,
      });

      return; // Early return to avoid setting state twice
    }

    // Recalculate Amount when BoxQty changes
    if (fieldName === "BoxQty" && gridData[index].Rate) {
      const boxQty = parseFloat(processedValue) || 0;
      // gridData[index].Amount = gridData[index].Rate * boxQty;
      gridData[index].Amount = parseFloat(
        (gridData[index].Rate * boxQty).toFixed(2)
      );
      console.log(
        "Amount recalculated due to BoxQty change:",
        gridData[index].Amount
      );
    }

    // If UnitSize is changed to 1 or 2, reset margin fields to 0
    if (fieldName === "UnitSize" && (value === "1" || value === "2")) {
      gridData[index]["LengthMar"] = "0";
      gridData[index]["WidthMar"] = "0";
      gridData[index]["HeightMar"] = "0";
    }

    this.setState({
      gridData,
      isFormDirty: true,
    });
  };

  handleMarFocus = (index, fieldName) => {
    this.setState({ activeMarField: `${index}-${fieldName}` });
  };

  handleMarBlur = () => {
    this.setState({ activeMarField: null });
  };

  gcd = (a, b) => {
    if (b === 0) {
      return a;
    }
    return this.gcd(b, a % b);
  };

  formatMargin = value => {
    if (!value || isNaN(value)) {
      return "";
    }
    const numerator = parseInt(value, 10);
    const denominator = 8;

    if (numerator === 0) {
      return "0";
    }

    const commonDivisor = this.gcd(numerator, denominator);
    const simplifiedNumerator = numerator / commonDivisor;
    const simplifiedDenominator = denominator / commonDivisor;

    if (simplifiedDenominator === 1) {
      return `${simplifiedNumerator}`;
    }

    return `${simplifiedNumerator}/${simplifiedDenominator}`;
  };

  // Helper method to check if margin fields should be disabled
  isMarginFieldDisabled = row => {
    return row.UnitSize === "1" || row.UnitSize === "2";
  };

  addGridRow = () => {
    const lastRow = this.state.gridData[this.state.gridData.length - 1];
    const newRow = {
      DOD: new Date().toISOString().split("T")[0],
      StyleNo: "",
      UnitSize: lastRow.UnitSize,
      ItemType: 1,
      Ply: "",
      Length: "",
      LengthMar: "",
      Width: "",
      WidthMar: "",
      Height: "",
      HeightMar: "",
      Type: "",
      CalcType: "",
      InOut: "",
      BoxQty: "",
      SqMt: "",
      Rate: "",
      Amount: "",
      index: this.state.gridData.length,
    };

    this.setState(
      prevState => ({
        gridData: [...prevState.gridData, newRow],
      }),
      () => {
        // After state update, focus the first enabled element of the new row
        const newRowIndex = this.state.gridData.length - 1;
        const enabledFields = this.getEnabledFieldOrder(newRowIndex);
        const firstFieldOfNewRow = document.querySelector(
          `[data-row="${newRowIndex}"][data-field="${enabledFields[0]}"]`
        );
        if (firstFieldOfNewRow) {
          firstFieldOfNewRow.focus();
          firstFieldOfNewRow.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    );
  };

  deleteGridRow = index => {
    if (this.state.gridData.length > 1) {
      const updatedGridData = this.state.gridData.filter((_, i) => i !== index);
      this.setState({ gridData: updatedGridData });
    }
    this.props.history.push(this.pushFormName);
  };

  async btnSave_onClick(event, formData) {
    try {
      // Validate BoxQty for all rows before saving
      const invalidRows = [];
      this.state.gridData.forEach((row, index) => {
        const boxQty = parseFloat(row.BoxQty) || 0;
        if (boxQty <= 0) {
          invalidRows.push(index + 1); // 1-based row number for user display
        }
      });

      if (invalidRows.length > 0) {
        // Show validation error and highlight invalid rows
        alert(
          `Please enter valid Box Quantity (> 0) for row(s): ${invalidRows.join(
            ", "
          )}`
        );

        // Highlight first invalid row
        const firstInvalidRowIndex = invalidRows[0] - 1; // Convert back to 0-based
        const invalidElement = document.querySelector(
          `[data-row="${firstInvalidRowIndex}"][data-field="BoxQty"]`
        );
        if (invalidElement) {
          invalidElement.focus();
          invalidElement.style.borderColor = "#dc3545";
          invalidElement.style.boxShadow = "0 0 5px rgba(220,53,69,0.5)";
          setTimeout(() => {
            invalidElement.style.borderColor = "";
            invalidElement.style.boxShadow = "";
          }, 3000);
        }
        return; // Stop save process
      }

      const obj = JSON.parse(sessionStorage.getItem("authUser"));

      // Calculate Total Amount from grid data
      const totalAmount = this.state.gridData.reduce((total, row) => {
        return total + (parseFloat(row.Amount) || 0);
      }, 0);

      const transformedGrid = this.state.gridData.map(item => ({
        CodeNo: item.StyleNo,
        F_PlyMaster: parseFloat(item.Ply) || 0,
        Length: parseFloat(item.Length) || 0,
        LengthMar: this.formatMargin(item.LengthMar),
        Width: parseFloat(item.Width) || 0,
        WidthMar: this.formatMargin(item.WidthMar),
        Height: parseFloat(item.Height) || 0,
        HeightMar: this.formatMargin(item.HeightMar),
        F_TypeMaster: parseFloat(item.Type) || 0,
        InOut: parseFloat(item.InOut) || 0,
        F_CalculationTypeMaster: parseFloat(item.CalcType) || 0,
        PrintDesc: parseFloat(item.PrintDesc) || 0,
        NoOfBox: parseFloat(item.BoxQty) || 0,
        F_UnitSize: parseFloat(item.UnitSize) || 0,
        DOD2: item.DOD || null,
        F_ItemType: parseFloat(item.ItemType) || 0,
        Rate: parseFloat(item.Rate) || 0,
        Amount: parseFloat(item.Amount) || 0,
        SqMt: parseFloat(item.SqMt) || 0,
      }));

      const vformData = new FormData();
      vformData.append("OrderNo", formData.OrderNo || "");
      vformData.append("OrderDate2", formData.OrderDate || null);
      vformData.append("DOD", formData.DeliveryDate || null);

      // Use customer's ledger ID if user role is Customer, otherwise use form data
      const ledgerId =
        this.state.newObj && this.state.newObj.UserRole === "Customer"
          ? this.state.newObj.LedgerId || this.state.newObj.F_LedgerMaster || 0
          : formData.LedgerId || 0;

      vformData.append("F_LedgerMaster", ledgerId);
      vformData.append("UserId", obj?.uid || 0);
      vformData.append("Amount", totalAmount);
      vformData.append("Id", formData.OrderId || 0); // Also appending Id if needed for update

      const res = await Fn_AddEditData(
        this.obj,
        { arguList: { id: formData.OrderId || 0, formData: vformData } },
        "InsertOrderH/0/token",
        this.pushFormName,
        true
      );
      console.log(res);

      if (res.data?.id) {
        const formData1 = new FormData();
        formData1.append("F_OrderDetailH", res.data.id);
        formData1.append("Data", JSON.stringify(transformedGrid));

        const res1 = await Fn_AddEditData(
          this.obj,
          { arguList: { id: 0, formData: formData1 } },
          "InsertOrderL/0/token",
          this.pushFormName,
          true
        );
        console.log(res1);
        if (res1.data?.id) {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error("Error saving order:", error);
    }
  }

  btnGoBack_onClick = event => {
    event.preventDefault();
    this.props.history.push(this.pushFormName);
  };

  btnCancel_onClick = event => {
    event.preventDefault();
    this.props.history.push(this.pushFormName);
  };

  // Helper method to get enabled fields for navigation
  getEnabledFieldOrder = rowIndex => {
    const row = this.state.gridData[rowIndex];
    const isMarginDisabled = this.isMarginFieldDisabled(row);

    if (isMarginDisabled) {
      // Return field order without margin fields
      return this.fieldOrder.filter(
        field => !["LengthMar", "WidthMar", "HeightMar"].includes(field)
      );
    }

    return this.fieldOrder;
  };

  // Add method to handle enter key navigation
  handleKeyPress = (event, rowIndex, fieldName) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();

      // Special handling for Amount field
      if (fieldName === "Amount") {
        // If this is the last row, add new row (if BoxQty > 0)
        if (rowIndex === this.state.gridData.length - 1) {
          const currentRow = this.state.gridData[rowIndex];
          const boxQty = parseFloat(currentRow.BoxQty) || 0;

          // Only add new row if BoxQty is greater than 0
          if (boxQty > 0) {
            // Add new row - focus will be set automatically by addGridRow function
            this.addGridRow();
          } else {
            // Show validation message for BoxQty
            const currentElement = document.querySelector(
              `[data-row="${rowIndex}"][data-field="BoxQty"]`
            );
            if (currentElement) {
              currentElement.style.borderColor = "#dc3545";
              currentElement.style.boxShadow = "0 0 5px rgba(220,53,69,0.5)";
              setTimeout(() => {
                currentElement.style.borderColor = "";
                currentElement.style.boxShadow = "";
              }, 2000);
            }
          }
        } else {
          // If not last row, move to the first field of next row
          const nextRowEnabledFields = this.getEnabledFieldOrder(rowIndex + 1);
          const nextRowElement = document.querySelector(
            `[data-row="${rowIndex + 1}"][data-field="${
              nextRowEnabledFields[0]
            }"]`
          );
          if (nextRowElement) {
            nextRowElement.focus();
          }
        }
        return;
      }

      const enabledFields = this.getEnabledFieldOrder(rowIndex);
      const currentFieldIndex = enabledFields.indexOf(fieldName);

      // If we are on the last field of the row (BoxQty)
      if (currentFieldIndex === enabledFields.length - 2) {
        // -2 because Amount is now last but handled separately
        // Move to Amount field
        const amountElement = document.querySelector(
          `[data-row="${rowIndex}"][data-field="Amount"]`
        );
        if (amountElement) {
          amountElement.focus();
        }
      } else if (currentFieldIndex === enabledFields.length - 1) {
        // This should not happen now since Amount is handled separately
        // But keeping for safety
        if (rowIndex === this.state.gridData.length - 1) {
          const currentRow = this.state.gridData[rowIndex];
          const boxQty = parseFloat(currentRow.BoxQty) || 0;

          if (boxQty > 0) {
            this.addGridRow();
          }
        } else {
          const nextRowEnabledFields = this.getEnabledFieldOrder(rowIndex + 1);
          const nextRowElement = document.querySelector(
            `[data-row="${rowIndex + 1}"][data-field="${
              nextRowEnabledFields[0]
            }"]`
          );
          if (nextRowElement) {
            nextRowElement.focus();
          }
        }
      } else {
        // Move to the next enabled field in the same row
        const nextFieldIndex = currentFieldIndex + 1;
        const nextField = enabledFields[nextFieldIndex];
        const nextElement = document.querySelector(
          `[data-row="${rowIndex}"][data-field="${nextField}"]`
        );
        if (nextElement) {
          nextElement.focus();
        }
      }
    }
  };

  // Add method to handle enter key navigation for form fields
  handleFormKeyPress = (event, currentField) => {
    if (event.key === "Enter") {
      event.preventDefault();

      // Create dynamic form field order based on user role
      let formFieldOrder = ["OrderNo", "OrderDate", "DeliveryDate"];

      // Only add LedgerId to navigation if user is not Customer
      if (!this.state.newObj || this.state.newObj.UserRole !== "Customer") {
        formFieldOrder.push("LedgerId");
      }

      const currentFieldIndex = formFieldOrder.indexOf(currentField);

      if (currentFieldIndex < formFieldOrder.length - 1) {
        // Move to the next form field
        const nextField = formFieldOrder[currentFieldIndex + 1];
        const nextElement = document.querySelector(`[name="${nextField}"]`);
        if (nextElement) {
          nextElement.focus();
        }
      } else {
        // If we're on the last form field, move to the first grid field
        const firstGridElement = document.querySelector(
          `[data-row="0"][data-field="${this.fieldOrder[0]}"]`
        );
        if (firstGridElement) {
          firstGridElement.focus();
        }
      }
    }
  };

  handleFormFieldChange = (fieldName, value) => {
    this.setState(prevState => {
      const newState = {
        formData: {
          ...prevState.formData,
          [fieldName]: value,
        },
        isFormDirty: true,
      };

      // If DeliveryDate is changed, update all DOD values in gridData
      if (fieldName === "DeliveryDate") {
        newState.DeliveryDate = value;
        newState.gridData = prevState.gridData.map(row => ({
          ...row,
          DOD: value,
        }));
      }

      return newState;
    });
  };

  handleAddClick = () => {
    // Reset form to initial state
    const today = new Date().toISOString().split("T")[0];

    // Set ledger ID based on user role
    const ledgerId =
      this.state.newObj && this.state.newObj.UserRole === "Customer"
        ? this.state.newObj.LedgerId || this.state.newObj.F_LedgerMaster || ""
        : "";

    // Reset all form fields and state
    this.setState(
      {
        formData: {
          OrderId: "",
          OrderNo: "",
          OrderDate: today,
          DeliveryDate: today,
          LedgerId: ledgerId,
        },
        OrderNo: "",
        OrderDate: today,
        DeliveryDate: today,
        LedgerId: ledgerId,
        gridData: [
          {
            DOD: today,
            StyleNo: "",
            UnitSize: "3",
            ItemType: 1,
            Ply: "",
            Length: "",
            LengthMar: "",
            Width: "",
            WidthMar: "",
            Height: "",
            HeightMar: "",
            Type: "",
            CalcType: "",
            InOut: "",
            BoxQty: "",
            SqMt: "",
            Rate: "",
            Amount: "",
            index: 0,
          },
        ],
        isFormDirty: false,
        isEditMode: false,
      },
      () => {
        // Force re-render of form fields
        const formElements = document.querySelectorAll("input, select");
        formElements.forEach(element => {
          if (element.type === "text" || element.type === "number") {
            element.value = "";
          } else if (element.type === "date") {
            element.value = today;
          } else if (element.tagName === "SELECT") {
            element.selectedIndex = 0;
          }
        });
        Fn_FillListData(
          this.obj,
          "OrderArr",
          API_WEB_URLS.MASTER + "/0/token/OrderDetailH/Id/0"
        );
        // Set focus on Order No field
        setTimeout(() => {
          const orderNoInput = document.querySelector('input[name="OrderNo"]');
          if (orderNoInput) {
            orderNoInput.focus();
          }
        }, 100);
      }
    );
  };

  handleCancelClick = () => {
    this.handleAddClick();
  };

  handleDeleteClick = () => {
    Fn_DeleteData(
      this.obj,
      this.state.OrderId,
      "Masters/0/token/OrderH",
      "Masters/0/token/OrderDetailH" + "/Id/0"
    );
    this.handleAddClick();
  };

  handleEditClick = () => {
    this.setState({ isEditMode: true });
  };

  handleFieldFocus = (index, fieldName) => {
    this.setState({ focusedField: `${index}-${fieldName}` });
  };

  handleFieldBlur = () => {
    this.setState({ focusedField: null });
  };

  handleFormFieldFocus = fieldName => {
    this.setState({ focusedFormField: fieldName });
  };

  handleFormFieldBlur = () => {
    this.setState({ focusedFormField: null });
  };

  handlePrintClick = async () => {
    console.log("OrderId:", this.state.formData.OrderId);
    if (this.state.formData.OrderId && this.state.formData.OrderId > 0) {
      let formData = new FormData();
      // If no ledger is selected, send 0 as the Id
      formData.append("Id", this.state.formData.OrderId);

      // Call each endpoint with the same form data
      await Fn_GetReport(
        this.obj,
        { arguList: { id: 0, formData: formData } },
        "GetOrderDetailH/0/token",
        "voucherHData",
        true
      );
      await Fn_GetReport(
        this.obj,
        { arguList: { id: 0, formData: formData } },
        "GetOrderDetailL/0/token",
        "voucherLData",
        true
      );

      await Fn_GetReport(
        this.obj,
        { arguList: { id: 0, formData: formData } },
        "GetHeaders/0/token",
        "headers",
        true
      );

      sessionStorage.setItem(
        "invoiceData",
        JSON.stringify({
          invoiceArray: this.state.voucherHData,
          firmArray: this.state.headers,
          items: this.state.voucherLData,
        })
      );
      window.open("/OrderPrint", "_blank");
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <div className="wizard clearfix">
                      <div className="content clearfix">
                        <AvForm
                          className="needs-validation"
                          onValidSubmit={this.btnSave_onClick}
                          onChange={() => this.setState({ isFormDirty: true })}
                        >
                          <TabContent
                            activeTab={this.state.activeTab}
                            className="body"
                          >
                            <TabPane tabId={1}>
                              <Row className="mt-3">
                                <Col sm="2" className="mb-3">
                                  <label
                                    htmlFor="ledger"
                                    className="col-form-label"
                                  >
                                    Order
                                  </label>
                                </Col>
                                <Col sm="4">
                                  <AvField
                                    type="select"
                                    name="OrderId"
                                    value={
                                      this.state.formData.OrderId === null
                                        ? ""
                                        : this.state.formData.OrderId
                                    }
                                    className="form-control"
                                    onChange={this.handleOrderChange}
                                    errorMessage="Select Order"
                                    style={{
                                      background:
                                        this.state.focusedFormField ===
                                        "OrderId"
                                          ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                          : "",
                                      transition: "background 0.3s ease",
                                      boxShadow:
                                        this.state.focusedFormField ===
                                        "OrderId"
                                          ? "0 0 5px rgba(0,123,255,0.5)"
                                          : "none",
                                    }}
                                    onFocus={() =>
                                      this.handleFormFieldFocus("OrderId")
                                    }
                                    onBlur={this.handleFormFieldBlur}
                                  >
                                    <option value="">Select Order</option>
                                    {this.state.OrderArr &&
                                      this.state.OrderArr.map(item => (
                                        <option key={item.Id} value={item.Id}>
                                          {item.Name}
                                        </option>
                                      ))}
                                  </AvField>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <Card>
                                    <CardBody>
                                      <h4 className="card-title mb-4">
                                        Order Details
                                      </h4>
                                      <Row>
                                        <Col sm="2" className="mb-3">
                                          <label
                                            htmlFor="orderNo"
                                            className="col-form-label"
                                          >
                                            Order No
                                          </label>
                                        </Col>
                                        <Col sm="2">
                                          <AvField
                                            name="OrderNo"
                                            value={
                                              this.state.formData.OrderNo ===
                                              null
                                                ? ""
                                                : this.state.formData.OrderNo
                                            }
                                            placeholder="Order No"
                                            errorMessage="Enter Order No"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            type="text"
                                            className="form-control"
                                            onChange={e =>
                                              this.handleFormFieldChange(
                                                "OrderNo",
                                                e.target.value
                                              )
                                            }
                                            style={{
                                              background:
                                                this.state.focusedFormField ===
                                                "OrderNo"
                                                  ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                  : "",
                                              transition:
                                                "background 0.3s ease",
                                              boxShadow:
                                                this.state.focusedFormField ===
                                                "OrderNo"
                                                  ? "0 0 5px rgba(0,123,255,0.5)"
                                                  : "none",
                                            }}
                                            onFocus={() =>
                                              this.handleFormFieldFocus(
                                                "OrderNo"
                                              )
                                            }
                                            onBlur={this.handleFormFieldBlur}
                                            onKeyPress={e =>
                                              this.handleFormKeyPress(
                                                e,
                                                "OrderNo"
                                              )
                                            }
                                          />
                                        </Col>

                                        <Col sm="2" className="mb-3">
                                          <label
                                            htmlFor="orderDate"
                                            className="col-form-label"
                                          >
                                            Order Date
                                          </label>
                                        </Col>
                                        <Col sm="2">
                                          <AvField
                                            name="OrderDate"
                                            value={
                                              this.state.formData.OrderDate ||
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            type="date"
                                            className="form-control"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            errorMessage="Select Order Date"
                                            onChange={e =>
                                              this.handleFormFieldChange(
                                                "OrderDate",
                                                e.target.value
                                              )
                                            }
                                            style={{
                                              background:
                                                this.state.focusedFormField ===
                                                "OrderDate"
                                                  ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                  : "",
                                              transition:
                                                "background 0.3s ease",
                                              boxShadow:
                                                this.state.focusedFormField ===
                                                "OrderDate"
                                                  ? "0 0 5px rgba(0,123,255,0.5)"
                                                  : "none",
                                            }}
                                            onFocus={() =>
                                              this.handleFormFieldFocus(
                                                "OrderDate"
                                              )
                                            }
                                            onBlur={this.handleFormFieldBlur}
                                            onKeyPress={e =>
                                              this.handleFormKeyPress(
                                                e,
                                                "OrderDate"
                                              )
                                            }
                                          />
                                        </Col>

                                        <Col sm="2" className="mb-3">
                                          <label
                                            htmlFor="deliveryDate"
                                            className="col-form-label"
                                          >
                                            Date of Delivery
                                          </label>
                                        </Col>
                                        <Col sm="2">
                                          <AvField
                                            name="DeliveryDate"
                                            value={
                                              this.state.formData
                                                .DeliveryDate ||
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            type="date"
                                            className="form-control"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            errorMessage="Select Delivery Date"
                                            onChange={e =>
                                              this.handleFormFieldChange(
                                                "DeliveryDate",
                                                e.target.value
                                              )
                                            }
                                            style={{
                                              background:
                                                this.state.focusedFormField ===
                                                "DeliveryDate"
                                                  ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                  : "",
                                              transition:
                                                "background 0.3s ease",
                                              boxShadow:
                                                this.state.focusedFormField ===
                                                "DeliveryDate"
                                                  ? "0 0 5px rgba(0,123,255,0.5)"
                                                  : "none",
                                            }}
                                            onFocus={() =>
                                              this.handleFormFieldFocus(
                                                "DeliveryDate"
                                              )
                                            }
                                            onBlur={this.handleFormFieldBlur}
                                            onKeyPress={e =>
                                              this.handleFormKeyPress(
                                                e,
                                                "DeliveryDate"
                                              )
                                            }
                                          />
                                        </Col>
                                      </Row>

                                      <Row className="mt-3">
                                        <Col sm="2" className="mb-3">
                                          <label
                                            htmlFor="ledger"
                                            className="col-form-label"
                                          >
                                            {this.state.newObj &&
                                            this.state.newObj.UserRole ===
                                              "Customer"
                                              ? "Ledger"
                                              : "Ledger"}
                                          </label>
                                        </Col>
                                        <Col sm="4">
                                          {this.state.newObj &&
                                          this.state.newObj.UserRole ===
                                            "Customer" ? (
                                            // Show customer name as h4 when UserRole is Customer
                                            <h4
                                              style={{
                                                margin: "0",
                                                padding: "8px 12px",
                                                backgroundColor: "#f8f9fa",
                                                border: "1px solid #dee2e6",
                                                borderRadius: "4px",
                                                color: "#495057",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                              }}
                                            >
                                              {this.state.newObj.Ledger ||
                                                "Customer Name"}
                                            </h4>
                                          ) : (
                                            // Show ledger dropdown for other roles
                                            <AvField
                                              type="select"
                                              name="LedgerId"
                                              value={
                                                this.state.formData.LedgerId ===
                                                null
                                                  ? ""
                                                  : this.state.formData.LedgerId
                                              }
                                              className="form-control"
                                              onChange={e => {
                                                this.handleLedgerChange(e);
                                                this.handleFormFieldChange(
                                                  "LedgerId",
                                                  e.target.value
                                                );
                                              }}
                                              validate={{
                                                required: { value: true },
                                              }}
                                              errorMessage="Select Ledger"
                                              style={{
                                                background:
                                                  this.state
                                                    .focusedFormField ===
                                                  "LedgerId"
                                                    ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                    : "",
                                                transition:
                                                  "background 0.3s ease",
                                                boxShadow:
                                                  this.state
                                                    .focusedFormField ===
                                                  "LedgerId"
                                                    ? "0 0 5px rgba(0,123,255,0.5)"
                                                    : "none",
                                              }}
                                              onFocus={() =>
                                                this.handleFormFieldFocus(
                                                  "LedgerId"
                                                )
                                              }
                                              onBlur={this.handleFormFieldBlur}
                                              onKeyPress={e =>
                                                this.handleFormKeyPress(
                                                  e,
                                                  "LedgerId"
                                                )
                                              }
                                            >
                                              <option value="">
                                                Select Ledger
                                              </option>
                                              {this.state.Ledger.map(item => (
                                                <option
                                                  key={item.Id}
                                                  value={item.Id}
                                                >
                                                  {item.Name}
                                                </option>
                                              ))}
                                            </AvField>
                                          )}
                                        </Col>
                                      </Row>

                                      {/* Grid System */}
                                      <div className="mt-4">
                                        <div
                                          style={{
                                            maxHeight: "400px",
                                            overflowY: "auto",
                                            overflowX: "auto",
                                            border: "1px solid #dee2e6",
                                            borderRadius: "4px",
                                            boxShadow:
                                              "0 0 10px rgba(0,0,0,0.1)",
                                          }}
                                        >
                                          <table
                                            className="table table-bordered table-hover mb-0"
                                            style={{ minWidth: "2020px" }}
                                          >
                                            <thead
                                              style={{
                                                position: "sticky",
                                                top: 0,
                                                backgroundColor: "#f8f9fa",
                                                zIndex: 1,
                                                borderBottom:
                                                  "2px solid #dee2e6",
                                              }}
                                            >
                                              <tr>
                                                <th
                                                  style={{
                                                    minWidth: "100px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  DOD
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "120px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Style No
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "100px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Unit Size
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "120px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Item Type
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "120px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Ply
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "80px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Length
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "90px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  LengthMar
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "80px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Width
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "90px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  WidthMar
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "80px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Height
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "90px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  HeightMar
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "120px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Type
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "120px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Calc Type
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "120px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Print Desc
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "80px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  In/Out
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "80px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Box Qty
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "100px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#e3f2fd",
                                                  }}
                                                >
                                                  SqMt
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "100px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#e3f2fd",
                                                  }}
                                                >
                                                  Rate
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "120px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#e3f2fd",
                                                  }}
                                                >
                                                  Amount
                                                </th>
                                                <th
                                                  style={{
                                                    minWidth: "90px",
                                                    padding: "12px 8px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    backgroundColor: "#f1f3f5",
                                                  }}
                                                >
                                                  Actions
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state.gridData.map(
                                                (row, index) => (
                                                  <tr
                                                    key={index}
                                                    style={{
                                                      backgroundColor:
                                                        index % 2 === 0
                                                          ? "#ffffff"
                                                          : "#f8f9fa",
                                                    }}
                                                  >
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        value={row.DOD}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "DOD",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-DOD`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-DOD`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "DOD"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "DOD"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="DOD"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={row.StyleNo}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "StyleNo",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-StyleNo`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-StyleNo`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "StyleNo"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "StyleNo"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="StyleNo"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <select
                                                        className="form-control form-control-sm"
                                                        value={row.UnitSize}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "UnitSize",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-UnitSize`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-UnitSize`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "UnitSize"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "UnitSize"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="UnitSize"
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        {this.state.UnitSize.map(
                                                          item => (
                                                            <option
                                                              key={item.Id}
                                                              value={item.Id}
                                                            >
                                                              {item.Name}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <select
                                                        className="form-control form-control-sm"
                                                        value={row.ItemType}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "ItemType",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-ItemType`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "all 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-ItemType`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                          appearance: "auto",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "ItemType"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "ItemType"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="ItemType"
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        {this.state.ItemType.map(
                                                          item => (
                                                            <option
                                                              key={item.Id}
                                                              value={item.Id}
                                                            >
                                                              {item.Name}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <select
                                                        className="form-control form-control-sm"
                                                        value={row.Ply}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "Ply",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Ply`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "all 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Ply`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                          appearance: "auto",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "Ply"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "Ply"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="Ply"
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        {this.state.Ply.map(
                                                          item => (
                                                            <option
                                                              key={item.Id}
                                                              value={item.Id}
                                                            >
                                                              {item.Name}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={row.Length}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "Length",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Length`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Length`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "Length"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "Length"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="Length"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={
                                                          this.isMarginFieldDisabled(
                                                            row
                                                          )
                                                            ? "0"
                                                            : this.state
                                                                .activeMarField ===
                                                              `${index}-LengthMar`
                                                            ? row.LengthMar
                                                            : this.formatMargin(
                                                                row.LengthMar
                                                              )
                                                        }
                                                        disabled={this.isMarginFieldDisabled(
                                                          row
                                                        )}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "LengthMar",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          textAlign: "center",
                                                          background:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? "#f8f9fa"
                                                              : this.state
                                                                  .focusedField ===
                                                                `${index}-LengthMar`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-LengthMar`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                          opacity:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? 0.6
                                                              : 1,
                                                          cursor:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? "not-allowed"
                                                              : "text",
                                                        }}
                                                        onFocus={() => {
                                                          if (
                                                            !this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                          ) {
                                                            this.handleFieldFocus(
                                                              index,
                                                              "LengthMar"
                                                            );
                                                            this.handleMarFocus(
                                                              index,
                                                              "LengthMar"
                                                            );
                                                          }
                                                        }}
                                                        onBlur={() => {
                                                          this.handleFieldBlur();
                                                          this.handleMarBlur();
                                                        }}
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "LengthMar"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="LengthMar"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={row.Width}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "Width",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Width`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Width`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "Width"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "Width"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="Width"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={
                                                          this.isMarginFieldDisabled(
                                                            row
                                                          )
                                                            ? "0"
                                                            : this.state
                                                                .activeMarField ===
                                                              `${index}-WidthMar`
                                                            ? row.WidthMar
                                                            : this.formatMargin(
                                                                row.WidthMar
                                                              )
                                                        }
                                                        disabled={this.isMarginFieldDisabled(
                                                          row
                                                        )}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "WidthMar",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          textAlign: "center",
                                                          background:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? "#f8f9fa"
                                                              : this.state
                                                                  .focusedField ===
                                                                `${index}-WidthMar`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-WidthMar`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                          opacity:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? 0.6
                                                              : 1,
                                                          cursor:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? "not-allowed"
                                                              : "text",
                                                        }}
                                                        onFocus={() => {
                                                          if (
                                                            !this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                          ) {
                                                            this.handleFieldFocus(
                                                              index,
                                                              "WidthMar"
                                                            );
                                                            this.handleMarFocus(
                                                              index,
                                                              "WidthMar"
                                                            );
                                                          }
                                                        }}
                                                        onBlur={() => {
                                                          this.handleFieldBlur();
                                                          this.handleMarBlur();
                                                        }}
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "WidthMar"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="WidthMar"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={row.Height}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "Height",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Height`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Height`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "Height"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "Height"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="Height"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={
                                                          this.isMarginFieldDisabled(
                                                            row
                                                          )
                                                            ? "0"
                                                            : this.state
                                                                .activeMarField ===
                                                              `${index}-HeightMar`
                                                            ? row.HeightMar
                                                            : this.formatMargin(
                                                                row.HeightMar
                                                              )
                                                        }
                                                        disabled={this.isMarginFieldDisabled(
                                                          row
                                                        )}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "HeightMar",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          textAlign: "center",
                                                          background:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? "#f8f9fa"
                                                              : this.state
                                                                  .focusedField ===
                                                                `${index}-HeightMar`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-HeightMar`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                          opacity:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? 0.6
                                                              : 1,
                                                          cursor:
                                                            this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                              ? "not-allowed"
                                                              : "text",
                                                        }}
                                                        onFocus={() => {
                                                          if (
                                                            !this.isMarginFieldDisabled(
                                                              row
                                                            )
                                                          ) {
                                                            this.handleFieldFocus(
                                                              index,
                                                              "HeightMar"
                                                            );
                                                            this.handleMarFocus(
                                                              index,
                                                              "HeightMar"
                                                            );
                                                          }
                                                        }}
                                                        onBlur={() => {
                                                          this.handleFieldBlur();
                                                          this.handleMarBlur();
                                                        }}
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "HeightMar"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="HeightMar"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <select
                                                        className="form-control form-control-sm"
                                                        value={row.Type}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "Type",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Type`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Type`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "Type"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "Type"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="Type"
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        {this.state.TypeMaster.map(
                                                          item => (
                                                            <option
                                                              key={item.Id}
                                                              value={item.Id}
                                                            >
                                                              {item.Name}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <select
                                                        className="form-control form-control-sm"
                                                        value={row.CalcType}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "CalcType",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-CalcType`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-CalcType`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "CalcType"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "CalcType"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="CalcType"
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        {this.state.CalculationType.map(
                                                          item => (
                                                            <option
                                                              key={item.Id}
                                                              value={item.Id}
                                                            >
                                                              {item.Name}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <select
                                                        className="form-control form-control-sm"
                                                        value={row.PrintDesc}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "PrintDesc",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-PrintDesc`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-PrintDesc`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "PrintDesc"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "PrintDesc"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="PrintDesc"
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        {this.state.PrintDescription && this.state.PrintDescription.map(
                                                          item => (
                                                            <option
                                                              key={item.Id}
                                                              value={item.Id}
                                                            >
                                                              {item.Name}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <select
                                                        className="form-control form-control-sm"
                                                        value={row.InOut}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "InOut",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-InOut`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-InOut`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "InOut"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "InOut"
                                                          )
                                                        }
                                                        data-row={index}
                                                        data-field="InOut"
                                                      >
                                                        {this.state.InOutOptions.map(
                                                          item => (
                                                            <option
                                                              key={item.Id}
                                                              value={item.Id}
                                                            >
                                                              {item.Name}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={row.BoxQty}
                                                        onChange={e =>
                                                          this.handleGridChange(
                                                            index,
                                                            "BoxQty",
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          background:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-BoxQty`
                                                              ? "linear-gradient(45deg, #f3f6f9, #ffffff)"
                                                              : "",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-BoxQty`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "BoxQty"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "BoxQty"
                                                          )
                                                        }
                                                        onKeyDown={e => {
                                                          if (
                                                            e.key === "Tab" &&
                                                            !e.shiftKey
                                                          ) {
                                                            e.preventDefault();
                                                            // Move to Amount field instead of save button
                                                            const amountElement =
                                                              document.querySelector(
                                                                `[data-row="${index}"][data-field="Amount"]`
                                                              );
                                                            if (amountElement) {
                                                              amountElement.focus();
                                                            }
                                                          }
                                                        }}
                                                        data-row={index}
                                                        data-field="BoxQty"
                                                      />
                                                    </td>
                                                    {/* SqMt Column */}
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={row.SqMt || ""}
                                                        disabled
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          textAlign: "right",
                                                          backgroundColor:
                                                            "#e3f2fd",
                                                          border:
                                                            "1px solid #bbdefb",
                                                          color: "#0d47a1",
                                                          fontWeight: "500",
                                                          cursor: "not-allowed",
                                                        }}
                                                        data-row={index}
                                                        data-field="SqMt"
                                                      />
                                                    </td>
                                                    {/* Rate Column */}
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={row.Rate || ""}
                                                        disabled
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          textAlign: "right",
                                                          backgroundColor:
                                                            "#e3f2fd",
                                                          border:
                                                            "1px solid #bbdefb",
                                                          color: "#0d47a1",
                                                          fontWeight: "500",
                                                          cursor: "not-allowed",
                                                        }}
                                                        data-row={index}
                                                        data-field="Rate"
                                                      />
                                                    </td>
                                                    {/* Amount Column */}
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={row.Amount || ""}
                                                        readOnly
                                                        style={{
                                                          fontSize: "13px",
                                                          height: "30px",
                                                          textAlign: "right",
                                                          backgroundColor:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Amount`
                                                              ? "#bbdefb"
                                                              : "#e3f2fd",
                                                          border:
                                                            "1px solid #bbdefb",
                                                          color: "#0d47a1",
                                                          fontWeight: "600",
                                                          cursor: "pointer",
                                                          transition:
                                                            "background 0.3s ease",
                                                          boxShadow:
                                                            this.state
                                                              .focusedField ===
                                                            `${index}-Amount`
                                                              ? "0 0 5px rgba(0,123,255,0.5)"
                                                              : "none",
                                                        }}
                                                        onFocus={() =>
                                                          this.handleFieldFocus(
                                                            index,
                                                            "Amount"
                                                          )
                                                        }
                                                        onBlur={
                                                          this.handleFieldBlur
                                                        }
                                                        onKeyPress={e =>
                                                          this.handleKeyPress(
                                                            e,
                                                            index,
                                                            "Amount"
                                                          )
                                                        }
                                                        onKeyDown={e => {
                                                          if (
                                                            e.key === "Tab" &&
                                                            !e.shiftKey
                                                          ) {
                                                            e.preventDefault();
                                                            // Move focus to Save button
                                                            const saveButton =
                                                              document.getElementById(
                                                                "saveButton"
                                                              );
                                                            if (saveButton) {
                                                              saveButton.focus();
                                                            }
                                                          }
                                                        }}
                                                        data-row={index}
                                                        data-field="Amount"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        padding: "8px 4px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <div className="d-flex justify-content-center">
                                                        <button
                                                          type="button"
                                                          className="btn btn-primary btn-sm"
                                                          onClick={
                                                            this.addGridRow
                                                          }
                                                          style={{
                                                            padding: "4px 8px",
                                                            marginRight: "4px",
                                                            fontSize: "12px",
                                                            lineHeight: "1",
                                                            minWidth: "26px",
                                                          }}
                                                        >
                                                          +
                                                        </button>
                                                        <button
                                                          type="button"
                                                          className="btn btn-danger btn-sm"
                                                          onClick={() =>
                                                            this.deleteGridRow(
                                                              index
                                                            )
                                                          }
                                                          style={{
                                                            padding: "4px 8px",
                                                            fontSize: "12px",
                                                            lineHeight: "1",
                                                            minWidth: "26px",
                                                          }}
                                                        >
                                                          -
                                                        </button>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>

                                        {/* Totals Section */}
                                        <div className="mt-3">
                                          <Row>
                                            <Col md="6"></Col>
                                            <Col md="6">
                                              <div className="d-flex justify-content-end">
                                                <div
                                                  style={{
                                                    backgroundColor: "#f8f9fa",
                                                    border: "2px solid #dee2e6",
                                                    borderRadius: "8px",
                                                    padding: "10px 15px",
                                                    boxShadow:
                                                      "0 2px 4px rgba(0,0,0,0.1)",
                                                    display: "flex",
                                                    gap: "30px",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "8px",
                                                    }}
                                                  >
                                                    <strong
                                                      style={{
                                                        fontSize: "14px",
                                                        color: "#495057",
                                                      }}
                                                    >
                                                      Total Qty:
                                                    </strong>
                                                    <strong
                                                      style={{
                                                        fontSize: "14px",
                                                        color: "#007bff",
                                                        fontWeight: "600",
                                                      }}
                                                    >
                                                      {this.state.gridData.reduce(
                                                        (total, row) => {
                                                          return (
                                                            total +
                                                            (parseFloat(
                                                              row.BoxQty
                                                            ) || 0)
                                                          );
                                                        },
                                                        0
                                                      )}
                                                    </strong>
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "8px",
                                                    }}
                                                  >
                                                    <strong
                                                      style={{
                                                        fontSize: "14px",
                                                        color: "#495057",
                                                      }}
                                                    >
                                                      Total Amount:
                                                    </strong>
                                                    <strong
                                                      style={{
                                                        fontSize: "14px",
                                                        color: "#28a745",
                                                        fontWeight: "600",
                                                      }}
                                                    >
                                                      {this.state.gridData.reduce(
                                                        (total, row) => {
                                                          return (
                                                            total +
                                                            (parseFloat(
                                                              row.Amount
                                                            ) || 0)
                                                          );
                                                        },
                                                        0
                                                      )}
                                                    </strong>
                                                  </div>
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            </TabPane>
                          </TabContent>
                          <div className="d-flex gap-2">
                            {this.state.formData.OrderId &&
                              !this.state.isEditMode && (
                                <Button
                                  type="button"
                                  color="success"
                                  className="waves-effect waves-light me-2"
                                  onClick={this.handleAddClick}
                                >
                                  Add
                                </Button>
                              )}
                            {this.state.isFormDirty && (
                              <Button
                                type="button"
                                color="warning"
                                className="waves-effect waves-light me-2"
                                onClick={this.handleCancelClick}
                              >
                                Cancel
                              </Button>
                            )}
                            {this.state.formData.OrderId &&
                              !this.state.isEditMode && (
                                <>
                                  <Button
                                    type="button"
                                    color="danger"
                                    className="waves-effect waves-light me-2"
                                    onClick={this.handleDeleteClick}
                                  >
                                    Delete
                                  </Button>
                                  <Button
                                    type="button"
                                    color="info"
                                    className="waves-effect waves-light me-2"
                                    onClick={this.handleEditClick}
                                  >
                                    Edit
                                  </Button>
                                </>
                              )}
                            {this.state.formData.OrderId &&
                              this.state.formData.OrderId > 0 && (
                                <Button
                                  type="button"
                                  color="secondary"
                                  className="waves-effect waves-light me-2"
                                  onClick={this.handlePrintClick}
                                >
                                  Print
                                </Button>
                              )}
                            {(!this.state.formData.OrderId ||
                              this.state.isEditMode) && (
                              <button
                                type="submit"
                                className="btn btn-primary waves-effect waves-light me-2"
                                id="saveButton"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #007bff, #0056b3)",
                                  border: "none",
                                  borderRadius: "6px",
                                  padding: "10px 20px",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  boxShadow: "0 4px 8px rgba(0,123,255,0.3)",
                                  transition: "all 0.3s ease",
                                  transform: "translateY(0)",
                                }}
                                onMouseEnter={e => {
                                  e.target.style.background =
                                    "linear-gradient(135deg, #0056b3, #004085)";
                                  e.target.style.boxShadow =
                                    "0 6px 12px rgba(0,123,255,0.4)";
                                  e.target.style.transform = "translateY(-2px)";
                                }}
                                onMouseLeave={e => {
                                  e.target.style.background =
                                    "linear-gradient(135deg, #007bff, #0056b3)";
                                  e.target.style.boxShadow =
                                    "0 4px 8px rgba(0,123,255,0.3)";
                                  e.target.style.transform = "translateY(0)";
                                }}
                                onFocus={e => {
                                  e.target.style.background =
                                    "linear-gradient(135deg, #28a745, #20c997)";
                                  e.target.style.boxShadow =
                                    "0 0 0 3px rgba(40,167,69,0.25), 0 6px 12px rgba(0,123,255,0.4)";
                                  e.target.style.transform = "translateY(-2px)";
                                  e.target.style.outline = "none";
                                }}
                                onBlur={e => {
                                  e.target.style.background =
                                    "linear-gradient(135deg, #007bff, #0056b3)";
                                  e.target.style.boxShadow =
                                    "0 4px 8px rgba(0,123,255,0.3)";
                                  e.target.style.transform = "translateY(0)";
                                }}
                                onKeyDown={e => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.target.style.background =
                                      "linear-gradient(135deg, #dc3545, #c82333)";
                                    e.target.style.transform =
                                      "translateY(1px)";
                                  }
                                }}
                                onKeyUp={e => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.target.style.background =
                                      "linear-gradient(135deg, #28a745, #20c997)";
                                    e.target.style.transform =
                                      "translateY(-2px)";
                                  }
                                }}
                              >
                                Save
                              </button>
                            )}
                      
                          </div>
                        </AvForm>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default compose(container)(pageAddEdit_Order);
